var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinDotOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6772 3.26437C14.1689 2.75609 13.2992 3.0194 13.1583 3.72427L12.7981 5.52483C12.7856 5.58758 12.7547 5.64521 12.7095 5.69046L9.82937 8.57059C9.77465 8.6253 9.70217 8.65864 9.62502 8.66457L5.11354 9.01161C4.82649 9.03369 4.55681 9.15772 4.35324 9.36129L4.26532 9.45922C3.88435 9.9328 3.91365 10.6273 4.35324 11.0669L8.007 14.72L3.2636 19.4644L3.18306 19.5565C2.91457 19.9093 2.94142 20.415 3.2636 20.7372C3.61508 21.0886 4.18492 21.0886 4.5364 20.7372L9.28 15.993L12.9339 19.6475C13.1374 19.8511 13.4071 19.9751 13.6942 19.9972C14.3583 20.0483 14.9381 19.5513 14.9892 18.8872L15.3362 14.3757C15.3421 14.2986 15.3755 14.2261 15.4302 14.1714L18.3103 11.2913C18.3556 11.246 18.4132 11.2152 18.4759 11.2026L20.2765 10.8425C20.9814 10.7015 21.2447 9.83188 20.7364 9.32359L14.6772 3.26437ZM14.5632 5.87784L14.593 5.72577L18.274 9.40677L18.1229 9.43758C17.7117 9.51982 17.334 9.72195 17.0375 10.0185L14.1574 12.8986L14.0296 13.0383C13.747 13.3764 13.5755 13.7953 13.5415 14.2377L13.293 17.4608L6.539 10.7068L9.76308 10.4593C10.2686 10.4204 10.7436 10.2019 11.1022 9.84338L13.9823 6.96326C14.2788 6.66672 14.4809 6.28905 14.5632 5.87784ZM10 4.5C10 5.32843 9.32843 6 8.5 6C7.67157 6 7 5.32843 7 4.5C7 3.67157 7.67157 3 8.5 3C9.32843 3 10 3.67157 10 4.5Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinDotOutline);
export default __webpack_public_path__ + "static/media/pin_dot_outline.9a126247c717939f10d851d22018adf9.svg";
export { ForwardRef as ReactComponent };